import { axiosApiService } from "./axios";

const InventoryListAPIs = {
  FilterInventoryListGet: async function({ accessToken, page = 1, search = '', page_size = 12, category = '', tag = '' }) {
    try {
      const response = await axiosApiService.get(`/admin_inventory_list/`, {
        params: {
          page,
          search,
          page_size,
          category,
          tag
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching Inventory list:', error);
      throw error;
    }
  },

  GetInventoryCategories: async function() {
    try {
      const response = await axiosApiService.get(`/admin_inventory_category_list/`);
      return response.data; // Usually an array of category objects
    } catch (error) {
      console.error('Error fetching Inventory categories:', error);
      return [];
    }
  },

  GetInventoryTags: function() {
    return ["Free", "Issue", "Purchase", "Exhaustible", "NonExhaustible", "InLabOnly", "HighValue"];
  }
};

export default InventoryListAPIs;